module.exports = __webpack_public_path__ + "2b6fc08745b1739a7ae7b03f8a3db8e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-dog-good-work.png
// module id = 2045
// module chunks = 4